import { render } from "./LabelStep.vue?vue&type=template&id=9b651278&scoped=true"
import script from "./LabelStep.vue?vue&type=script&lang=js"
export * from "./LabelStep.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9b651278"

export default script